import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '@/static/icons/search-icon.svg'
import _imports_1 from '@/static/icons/plus-sign.svg'
import _imports_2 from '@/static/icons/cancel_white_icon.svg'


const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "dropdown__placeholder-container" }
const _hoisted_5 = {
  key: 0,
  class: "dropdown__selected-value"
}
const _hoisted_6 = {
  key: 1,
  class: "dropdown__placeholder-container__loading-dots"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown__placeholder-container__loading-dots__first-dot" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown__placeholder-container__loading-dots__second-dot" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown__placeholder-container__loading-dots__third-dot" }, null, -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "dropdown__search"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "dropdown__search-input-icon",
  src: _imports_0
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "dropdown__new-option-icon",
  src: _imports_1
}, null, -1)
const _hoisted_14 = { class: "dropdown__new-option-caption" }
const _hoisted_15 = {
  key: 2,
  class: "dropdown__selected-options"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["value", "onClick", "onMousemove"]

import { computed, ref, watch, nextTick, onBeforeUnmount } from 'vue';

import useDeviceHeight from '@/composables/useDeviceHeight';

import ErrorMessage from '@/components/forms/ErrorMessage.vue';
import ArrowExpandable from '@/components/ArrowExpandable.vue';
import TextInput from '@/components/forms/TextInput.vue';

interface IOption {
  value: number | string;
  text: string;
  isSelected?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
  id: {
    type: String,
  },
  options: {
    type: Array<{
      value: number | string;
      text: string;
      isSelected?: boolean;
    }>,
    required: true,
  },
  placeholder: {
    type: String,
    default: null,
  },
  searchPlaceholder: {
    type: String,
    default: null,
  },
  label: {
    type: String,
  },
  addOptionLabel: {
    type: String,
  },
  modelValue: {
    type: [String, Number],
  },
  modelValues: {
    type: [Array<any>],
  },
  errorMessage: {
    type: String,
  },
  addOption: {
    type: Boolean,
  },
  enableSearch: {
    type: Boolean,
    default: false,
  },
  multipleSelect: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
  },
  selectOptionHandler: {
    type: Function,
  },
},
  emits: [
  'update:modelValue',
  'update:modelValues',
  'change',
  'focus',
  'blur',
  'add-option',
],
  setup(__props, { expose, emit }) {

const props = __props;





expose({
  closeDropdown,
});

const { clientHeight } = useDeviceHeight();

const dropdownContainerEl = ref<HTMLDivElement | null>(null);
const dropdownEl = ref<HTMLDivElement | null>(null);
const searchInputEl = ref<HTMLInputElement | null>(null);
const optionsEl = ref<HTMLDivElement[] | null>(null);

const selectOptionRequestPending = ref(false);

const isInputFocused = ref(false);
const isExpanded = ref(false);
const dropdownContainerFocused = ref(false);
const focusedIndex = ref(-1);
const searchPhrase = ref('');
const selectedOptions = ref<IOption[]>([]);
const availableViewHeight: number = 35;

const dropdownOptions = computed((): IOption[] => {
  return JSON.parse(
    JSON.stringify((props.options || []).filter((e) => e.value))
  );
});

const filteredOptions = computed(() => {
  if (!searchPhrase.value) {
    return dropdownOptions.value;
  }
  const normalizedSearchPhrase = searchPhrase.value.toLowerCase();

  const options = dropdownOptions.value.filter((f) => {
    return f.value && f.text.toLowerCase().includes(normalizedSearchPhrase);
  });
  return options;
});

const selectedModelValuesOptions: any = computed(() => {
  if (!props.multipleSelect) {
    const returnValue = dropdownOptions.value.find(
      (r) => r.value == props.modelValue || r.isSelected
    );
    return returnValue;
  }

  const returnValues = dropdownOptions.value.filter(
    (r) => props.modelValues?.find((k) => k == r.value) || r.isSelected
  );

  return returnValues;
});

const selectedText = computed(() => {
  if (!props.multipleSelect) {
    return (
      selectedModelValuesOptions.value?.text ||
      selectedModelValuesOptions.value?.value ||
      ''
    );
  }
  return (
    selectedModelValuesOptions.value?.[0]?.text ||
    selectedModelValuesOptions.value?.[0]?.value ||
    ''
  );
});

const moreSelected = computed(() => {
  return selectedOptions.value.length;
});

const showPlaceholder = computed(() => {
  return !(props.modelValue || (props.modelValues || []).length > 0);
});

const isActive = computed(() => {
  return dropdownContainerFocused.value && isExpanded.value;
});

const shouldDisplayAboveDropdown = computed(() => {
  if (!dropdownContainerEl.value) return;
  const remainingSpaceBelowDropdown =
    clientHeight.value -
    dropdownContainerEl.value.getBoundingClientRect().bottom;
  
  const numberRegex = /^\d*\.?\d+/;
  const oneViewHeight = document.documentElement.style.getPropertyValue('--vh')
  const matches = oneViewHeight.match(numberRegex);
  if (!matches) {
    return true;
  }

  const oneViewHeightNumeric = Number(matches[0]);
  const availableHeightInPixels = oneViewHeightNumeric * availableViewHeight;
  return remainingSpaceBelowDropdown < availableHeightInPixels;
});

watch(
  () => props.modelValues || props.modelValue,
  () => {
    if (props.modelValues && props.multipleSelect) {
      props.modelValues.forEach((p) => {
        dropdownOptions.value.forEach((o) => {
          if (o.value == p) {
            o.isSelected = true;
            return;
          }
        });
      });
      updateSelectedOptions();
    } else {
      dropdownOptions.value?.forEach((o) => {
        if (o.value == props.modelValue) {
          o.isSelected = true;
          return;
        }
      });
    }
  },
  {
    immediate: true,
  }
);

watch(isExpanded, (val) => {
  searchPhrase.value = '';
  if (isExpanded) {
    nextTick(() => {
      searchInputEl.value?.focus();
    });
  }

  if (val) {
    document.addEventListener('mousedown', shrinkOnClickOutside);
  } else {
    document.removeEventListener('mousedown', shrinkOnClickOutside);
  }
});

onBeforeUnmount(() => {
  if (!isExpanded)
    document.removeEventListener('mousedown', shrinkOnClickOutside);
});

function updateSelectedOptions() {
  selectedOptions.value =
    dropdownOptions.value.filter((e) => e.isSelected) || [];
}

async function executeSelectOptionHandler(option: IOption) {
  try {
    selectOptionRequestPending.value = true;
    await props.selectOptionHandler?.(option);
  } catch (err) {
    option.isSelected = false;
    console.error(err);
    throw err;
  } finally {
    selectOptionRequestPending.value = false;
  }
}

async function selectOption(option: IOption) {
  if (!option) return;

  if (!props.multipleSelect) {
    dropdownOptions.value.forEach((e) => {
      e.isSelected = false;
    });
    option.isSelected = !option.isSelected;

    isExpanded.value = false;

    if (props.selectOptionHandler) {
      await executeSelectOptionHandler(option);
    }

    emit('update:modelValue', option.value);
    emit('change', option);
    emit('blur');
  } else {
    option.isSelected = !option.isSelected;

    if (props.selectOptionHandler) {
      await executeSelectOptionHandler(option);
    }

    updateSelectedOptions();
    const values = selectedOptions.value.map((e) => e.value);

    emit('update:modelValues', values);
    emit('change', option);
  }
}

function isFocused(index: number) {
  return focusedIndex.value === index;
}

function scrollToFocusedElement() {
  if (!isExpanded.value || !dropdownEl.value || !optionsEl.value) return;

  const elementHeight = optionsEl.value[focusedIndex.value]?.offsetHeight;
  dropdownEl.value.scrollTo(0, focusedIndex.value * elementHeight);
}

function checkKeypress(event: KeyboardEvent) {
  if (!dropdownContainerFocused.value) return;
  switch (event.key) {
    case 'ArrowDown':
      event.preventDefault();
      isExpanded.value = true;
      focusedIndex.value += 1;
      focusedIndex.value %= filteredOptions.value.length;

      scrollToFocusedElement();

      break;
    case 'ArrowUp':
      event.preventDefault();
      if (isActive.value) {
        focusedIndex.value =
          focusedIndex.value > 0
            ? focusedIndex.value - 1
            : dropdownOptions.value.length - 1;
        focusedIndex.value %= filteredOptions.value.length;
        scrollToFocusedElement();
      }
      break;
    case 'Enter':
      if (isActive.value) {
        selectOption(filteredOptions.value[focusedIndex.value]);
      }
      break;
    case 'Escape':
      isExpanded.value = false;
      break;
    case 'Backspace':
      if (!selectedOptions.value.length || isInputFocused.value) return;
      const element = selectedOptions.value.pop();
      dropdownOptions.value.forEach((e) => {
        if (e.value === element?.value) e.isSelected = false;
      });
      break;
    default:
      handleDropdownLetterKey(event);
  }
}

function handleDropdownLetterKey(event: KeyboardEvent) {
  const matchingOptions = dropdownOptions.value
    .map((o, i) => ({ text: o.text, index: i }))
    .filter((o) => o.text?.toLowerCase()?.startsWith(event.key?.toLowerCase()))
    .map((o) => o.index);
  if (!matchingOptions.length) return;
  isExpanded.value = true;
  const resetIndex =
    focusedIndex.value === matchingOptions[matchingOptions.length - 1] ||
    focusedIndex.value === -1 ||
    !dropdownOptions.value[focusedIndex.value].text
      .toLowerCase()
      .startsWith(event.key.toLowerCase());

  focusedIndex.value = resetIndex
    ? matchingOptions[0]
    : matchingOptions.find((c) => c > focusedIndex.value)!;
  scrollToFocusedElement();
}

function setFocus(index: number) {
  focusedIndex.value = index;
}

function resetFocus() {
  focusedIndex.value = -1;
}

function toggleDropdown() {
  if (isExpanded.value) {
    closeDropdown();
  } else {
    openDropdown();
  }
}

function shrinkOnClickOutside(event: any) {
  if (
    dropdownContainerEl.value &&
    event.target &&
    !dropdownContainerEl.value.contains(event.target) &&
    !selectOptionRequestPending.value
  ) {
    closeDropdown();
  }
}

function openDropdown() {
  isExpanded.value = true;
}

function closeDropdown() {
  isExpanded.value = false;
  dropdownContainerFocused.value = false;
  emit('blur');
}

function deleteOption(value: number | string) {
  dropdownOptions.value.forEach((el) => {
    if (el.value === value) el.isSelected = false;
  });
  const values = (props.modelValues as any)?.filter(
    (e: number | string) => e !== value
  );
  emit('update:modelValues', values);
}

function onChangeInputFocus() {
  isInputFocused.value = !isInputFocused.value;
}

function onChangeDropdownContainerFocus() {
  dropdownContainerFocused.value = !dropdownContainerFocused.value;
  resetFocus();
  emit('focus');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropdown",
    tabindex: "0",
    onMouseleave: resetFocus,
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (onChangeDropdownContainerFocus())),
    onKeydown: checkKeypress,
    ref_key: "dropdownContainerEl",
    ref: dropdownContainerEl
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["dropdown__label", { 'dropdown__multiselect-label': __props.multipleSelect }]),
          for: __props.id
        }, _toDisplayString(__props.label), 11, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: __props.id,
      class: _normalizeClass(["dropdown__container", [
        { 'dropdown--error-message': __props.errorMessage },
        {
          'dropdown__container--disabled': __props.disabled,
        },
        {
          'dropdown__container--request-pending': selectOptionRequestPending.value,
        },
      ]])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["dropdown__placeholder", {
          'dropdown__selected-value': !_unref(showPlaceholder),
          'dropdown__selected-value-multiple': __props.multipleSelect,
        }]),
        onClick: _withModifiers(toggleDropdown, ["prevent","stop"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "selected", {
            placeholder: __props.placeholder,
            selectedText: _unref(selectedText),
            selected: _unref(selectedModelValuesOptions)
          }, () => [
            _createTextVNode(_toDisplayString(_unref(showPlaceholder) ? __props.placeholder : _unref(selectedText)), 1)
          ]),
          (__props.multipleSelect)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "selected-more", { moreSelected: _unref(moreSelected) })
              ]))
            : _createCommentVNode("", true)
        ]),
        (!selectOptionRequestPending.value)
          ? (_openBlock(), _createBlock(ArrowExpandable, {
              key: 0,
              expanded: isExpanded.value
            }, null, 8, ["expanded"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_10))
      ], 10, _hoisted_3),
      _createVNode(_Transition, { name: "expand" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            ref_key: "dropdownEl",
            ref: dropdownEl,
            class: _normalizeClass(["dropdown__select", { 'dropdown__direction-above': _unref(shouldDisplayAboveDropdown) }])
          }, [
            (__props.enableSearch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(TextInput, {
                    placeholder: __props.searchPlaceholder,
                    modelValue: searchPhrase.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event)),
                    ref_key: "searchInputEl",
                    ref: searchInputEl,
                    onFocus: onChangeInputFocus,
                    onBlur: onChangeInputFocus
                  }, null, 8, ["placeholder", "modelValue"]),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true),
            (__props.addOption)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "dropdown__new-option",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('add-option', searchPhrase.value))),
                  tabindex: "-1"
                }, [
                  (__props.addOption)
                    ? _renderSlot(_ctx.$slots, "add-option", { key: 0 }, () => [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, _toDisplayString(__props.addOptionLabel), 1)
                      ])
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (__props.multipleSelect && selectedOptions.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (selectedOption) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: selectedOption.value,
                      class: "dropdown__selected-options__item"
                    }, [
                      _createElementVNode("p", null, _toDisplayString(selectedOption.text), 1),
                      _createElementVNode("img", {
                        onClick: ($event: any) => (deleteOption(selectedOption.value)),
                        class: "dropdown__selected-options__item-icon",
                        src: _imports_2
                      }, null, 8, _hoisted_16)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredOptions), (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.value,
                tabindex: "0",
                value: option.value,
                class: _normalizeClass(["dropdown__option", {
              'dropdown__option--selected':
                option.isSelected && !__props.multipleSelect,
              'dropdown__option--hover': isFocused(index),
              'dropdown__option--hide': option.isSelected && __props.multipleSelect,
            }]),
                onClick: ($event: any) => (selectOption(option)),
                onMousemove: ($event: any) => (setFocus(index)),
                ref_for: true,
                ref_key: "optionsEl",
                ref: optionsEl
              }, [
                _renderSlot(_ctx.$slots, "option", {
                  option: option,
                  isSelected: option?.isSelected
                }, () => [
                  _createTextVNode(_toDisplayString(option.text), 1)
                ])
              ], 42, _hoisted_17))
            }), 128))
          ], 2), [
            [_vShow, isExpanded.value]
          ])
        ]),
        _: 3
      })
    ], 10, _hoisted_2),
    _createVNode(ErrorMessage, { message: __props.errorMessage }, null, 8, ["message"])
  ], 544))
}
}

})